const opacity = {
  15: 0.15,
}
export type IOpacity = keyof typeof opacity

export default opacity
